import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import simpleReactportsValidator from 'simple-react-validator';

import BlankState from '../../components/BlankState';
import DataTable from '../../components/DataTable';
import Page from '../../components/Page';
import { TabHolder, Tab } from '../../components/Tabs';
import StatusMessages from '../../components/StatusMessages';

import { getCountries, getConveyance, getPorts } from '../../utils/apiService';
import {
  saveCountryFlag,
  savePortsFlag,
  updateCountryFlag,
  listCountryFlags,
  listPortFlags
} from '../../actions/flagged';
class Flagged extends Component {
  constructor(props) {
    super(props);
    this.portsValidator = new simpleReactportsValidator();
    this.countryValidator = new simpleReactportsValidator();
    this.state = {
      countries: [],
      ports: [],
      conveyance: [],
      convey: {},
      port: {},
      country: {},
      conveyance_type: {},
      flagged_country: {
        insurer: '',
        country: '',
        reason: '',
        flagged: '',
        is_flagged: ''
      },
      flagged_port: {
        port: '',
        country: '',
        insurer: '',
        conveyance_type: '',
        reason: '',
        flagged: true,
        is_flagged: true
      },
      flagged_loading: true
    };
  }

  componentDidMount() {
    this.props.listCountryFlags();
    this.props.listPortFlags();
    getCountries().then(response => {
      this.setState({ countries: response.data });
    });
    getConveyance().then(response => {
      this.setState({ conveyance: response.data });
    });
    this.getPort();
  }
  getPort() {
    const country = this.state.flagged_port.country;
    console.log(country);
    getPorts(country).then(response => {
      this.setState({ ports: response.data });
    });
  }

  onChangeCountryFlag = e => {
    e.preventDefault();

    const { flagged_country } = this.state;
    const { name, value } = e.target;

    this.setState({
      flagged_country: {
        ...flagged_country,
        insurer: this.props.user.userInfo.insurer,
        is_flagged: true,
        flagged: true,
        [name]: value
      }
    });
  };
  onChangePortsFlag = e => {
    e.preventDefault();

    const { flagged_port } = this.state;
    const { name, value } = e.target;

    this.setState(
      {
        flagged_port: {
          ...flagged_port,
          insurer: this.props.user.userInfo.insurer,
          is_flagged: true,
          flagged: true,
          [name]: value
        }
      },
      () => {
        this.getPort();
      }
    );
  };

  createFlag = e => {
    e.preventDefault();
    if (this.countryValidator.allValid()) {
      this.countryValidator.hideMessages();
      const { flagged_country } = this.state;
      if (flagged_country) {
        this.props.saveCountryFlag(flagged_country);
      }
    } else {
      this.countryValidator.showMessages();
      this.forceUpdate();
    }
  };

  createPortBlackList = e => {
    e.preventDefault();
    if (this.portsValidator.allValid()) {
      this.portsValidator.hideMessages();
      const { flagged_port } = this.state;

      if (flagged_port) {
        this.props.savePortsFlag(this.state.flagged_port);
      }
    } else {
      this.portsValidator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const menuItems = [
      { id: 'countries', name: 'Country', active: true },
      { id: 'ports', name: 'Ports' }
    ];

    let { flagged_loading, countries, conveyance, ports } = this.state;

    const { flags } = this.props;

    return (
      <Page isAdminPage={true} pageTitle="Flagged/Blacklisted">
        <TabHolder menuItems={menuItems}>
          <Tab menuId={menuItems[0].id} isActive={true}>
            <div className="col-md-4">
              <form
                className="form-horizontal"
                noValidate
                onSubmit={this.createFlag}
              >
                {flags.error
                  ? Object.keys(flags.errorMessage).map(key => {
                      return (
                        <StatusMessages
                          type="error"
                          message={key + ' ' + flags.errorMessage[key]}
                        />
                      );
                    })
                  : null}
                {flags.createCountryFlagSuccess ? (
                  <StatusMessages
                    type="success"
                    message="Country Flag Created!"
                  />
                ) : null}
                <div className="form-group">
                  <label>Country:</label>
                  {countries.length > 0 ? (
                    <select
                      className="form-control"
                      onChange={this.onChangeCountryFlag}
                      name="country"
                      required
                    >
                      <option value="">Select Country </option>
                      {countries.map((country, index) => {
                        return (
                          <option key={index} value={country.id}>
                            {country.name}
                          </option>
                        );
                      })}
                      }
                    </select>
                  ) : (
                    'Loading...'
                  )}
                  {this.countryValidator.message(
                    'country',
                    this.state.flagged_country.country,
                    'required',
                    'text-danger'
                  )}
                </div>

                <div className="form-group">
                  <label>Reason:</label>
                  <textarea
                    name="reason"
                    onChange={this.onChangeCountryFlag}
                    rows="5"
                    cols="5"
                    className="form-control"
                    required
                  />
                  {this.countryValidator.message(
                    'reason',
                    this.state.flagged_country.reason,
                    'required',
                    'text-danger'
                  )}
                </div>

                <div className="form-group">
                  <button type="submit" className="btn btn-success">
                    <i className="icon ion-plus" /> Add Country to Blacklist
                  </button>
                </div>
              </form>
            </div>

            <div className="col-md-7 col-md-offset-1">
              {flags.flagged_countries.length > 0 ? (
                <DataTable
                  tableId="countries-table"
                  columnTitles={['Country', 'Reason']}
                >
                  {flags.flagged_countries.map((flag, index) => {
                    return (
                      <tr key={index}>
                        <td>{flag.name}</td>
                        <td>{flag.reason}</td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={flags.flagged_countries}
                  dataName="Flagged Countries"
                  isDataLoading={flagged_loading}
                />
              )}
            </div>
          </Tab>

          <Tab menuId={menuItems[1].id}>
            <div className="col-md-4">
              <form
                className="form-horizontal"
                noValidate
                onSubmit={this.createPortBlackList}
              >
                {flags.error
                  ? Object.keys(flags.errorMessage).map(key => {
                      return (
                        <StatusMessages
                          type="error"
                          message={key + ' ' + flags.errorMessage[key]}
                        />
                      );
                    })
                  : null}
                {flags.createPortFlagSuccess ? (
                  <StatusMessages type="success" message="Port Flag Created!" />
                ) : null}
                <div className="form-group">
                  <label>Country:</label>
                  {countries.length > 0 ? (
                    <select
                      className="form-control"
                      onChange={this.onChangePortsFlag}
                      name="country"
                    >
                      <option value="">Select Country </option>
                      {countries.map((country, index) => {
                        return (
                          <option key={index} value={country.id}>
                            {country.name}
                          </option>
                        );
                      })}
                      }
                    </select>
                  ) : (
                    'Loading Countries..'
                  )}
                  {this.portsValidator.message(
                    'country',
                    this.state.flagged_port.country,
                    'required',
                    'text-danger'
                  )}
                </div>
                <div className="form-group">
                  <label>Port:</label>
                  {ports.length > 0 ? (
                    <select
                      className="form-control"
                      onChange={this.onChangePortsFlag}
                      name="port"
                      required
                    >
                      <option value="">Select Port </option>
                      {ports.map((port, index) => {
                        return (
                          <option key={index} value={port.id}>
                            {port.name}
                          </option>
                        );
                      })}
                    </select>
                  ) : (
                    'Loading Ports...'
                  )}
                  {this.portsValidator.message(
                    'port',
                    this.state.flagged_port.port,
                    'required',
                    'text-danger'
                  )}
                </div>

                <div className="form-group">
                  <label>Conveyance:</label>
                  {conveyance.length > 0 ? (
                    <select
                      className="form-control"
                      onChange={this.onChangePortsFlag}
                      name="conveyance_type"
                      required
                    >
                      <option value="">Select Conveyance </option>
                      {conveyance.map((convey, index) => {
                        return (
                          <option key={index} value={convey.id}>
                            {convey.conveyance_type}
                          </option>
                        );
                      })}
                      }
                    </select>
                  ) : null}
                  {this.portsValidator.message(
                    'conveyance',
                    this.state.flagged_port.conveyance_type,
                    'required',
                    'text-danger'
                  )}
                </div>

                <div className="form-group">
                  <label>Reason:</label>
                  <textarea
                    name="reason"
                    onChange={this.onChangePortsFlag}
                    rows="5"
                    cols="5"
                    className="form-control"
                    required
                  />
                  {this.portsValidator.message(
                    'reason',
                    this.state.flagged_port.reason,
                    'required',
                    'text-danger'
                  )}
                </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-success">
                    <i className="icon ion-plus" /> Add Port to Blacklist
                  </button>
                </div>
              </form>
            </div>

            <div className="col-md-7 col-md-offset-1">
              {flags.flagged_ports.length > 0 ? (
                <DataTable
                  tableId="ports-table"
                  columnTitles={['Country', 'Port', 'Conveyance', 'Reason']}
                >
                  {flags.flagged_ports.map((port, index) => {
                    return (
                      <tr key={index}>
                        <td>{port.country}</td>
                        <td>{port.name}</td>
                        <td>{port.conveyance}</td>
                        <td>{port.reason}</td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={flags.flagged_ports}
                  dataName="Ports"
                  isDataLoading={flagged_loading}
                />
              )}
            </div>
          </Tab>
        </TabHolder>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  flags: state.flags
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      listCountryFlags,
      updateCountryFlag,
      saveCountryFlag,
      savePortsFlag,
      listPortFlags
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Flagged);



// WEBPACK FOOTER //
// ./src/pages/dashboard/Flagged.jsx